import { generateLocalizedRouteConfig, LocalizedRoutes } from '@/router/localizedRouting';
import { LISTING_REDIRECT_PATHS } from '@/router/routes/constants';
import { Pages } from '@/types';
import { RouteRecordRaw } from 'vue-router';

const routes: LocalizedRoutes = {
  de: { path: LISTING_REDIRECT_PATHS['de'] },
  en: { path: LISTING_REDIRECT_PATHS['en'] },
  fr: { path: LISTING_REDIRECT_PATHS['fr'] },
  it: { path: LISTING_REDIRECT_PATHS['it'] },
};

const Component = () => import('@/pages/ListingRedirectPage/ListingRedirectPage.vue');

const localizedRouteConfig = (): RouteRecordRaw[] =>
  generateLocalizedRouteConfig(routes, Component, Pages.ListingRedirect);

export default localizedRouteConfig;
